import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ShoppingLists from './pages/ShoppingLists';
import ProductSearch from './pages/ProductSearch';
import Receipts from './pages/Receipts';
import BasketCompare from './pages/BasketCompare';
import Settings from './pages/Settings';
import Home from './pages/Home';

import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/shopping-lists" element={<ShoppingLists />} />
          <Route path="/shopping-lists/:listId/compare" element={<BasketCompare />} />
          <Route path="/product-search" element={<ProductSearch />} />
          <Route path="/receipts" element={<Receipts />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
